import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {API_URL} from "lib-base";
import {Observable} from "rxjs";
import {
  ITipoSolicitudesDisponiblesPQRSDF,
  ITipoSolicitudPQRSDF
} from "../../shared/interfaces/pqrsdf";

@Injectable({
  providedIn: 'root'
})
export class TipoPqrsdfService {

  private baseUrl: string ;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/tipos-pqrsd`;
  }

  getAll():Observable<ITipoSolicitudPQRSDF[]>{
    const url = `${this.baseUrl}/public`;
    return this.http.get<ITipoSolicitudPQRSDF[]>(url);
  }

  getSolicitudesDisponibles(): Observable<Required<ITipoSolicitudesDisponiblesPQRSDF>[]> {
    const url = `${this.baseUrl}/public/disponible`;
    return this.http.get<Required<ITipoSolicitudesDisponiblesPQRSDF>[]>(url);
  }
}
